








import { Component, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import majorShowFirst from './majorShowFirst.vue'
import majorAdd from './majorAdd.vue'
@Component({
  components: {
    majorShowFirst,
    majorAdd,
  },
})
export default class MajorModify extends Vue {
  private showPage: boolean = true
  private msg: any = []
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  parentShow(val: any) {
    this.showPage = false
  }
  paentChoose(val: any) {
    this.msg.push(val)
    this.showPage = true
    setTimeout(() => {
      // @ts-ignore
      this.$refs.firstChild.keep(false);
    })
  }
  //初步获取专业信息并赋值
  created() {
    // for(let i = 0;i <this.userInfo.majors.length;i ++){

    // }
    // this.$store.dispatch('setUserInfo').then(() => {
    //   this.$router.back()
    // })
    this.msg=this.userInfo.majors
  }
}
